import { useListClientsQuery } from '~/api/endpoints/clients'
import { useAppDispatch } from '~/app/hooks'
import { clientSelected } from '~/app/clientSlice'
import { Select } from '~/components/primitives/Field'
import { useSelectedClientId } from './useClients'

const ALL = ''

/**
 * "All clients" or one client (BIBLE §19). Every list in the console — campaigns,
 * accounts, tables, the inbox, the overview — shows only the chosen client's things.
 */
export function ClientSwitcher() {
  const dispatch = useAppDispatch()
  const selected = useSelectedClientId()
  const { data } = useListClientsQuery()
  const clients = (data?.items ?? [])
    .map((listing) => listing.client)
    // An archived client stays offered only while it is the one chosen, so the
    // selection never points at nothing.
    .filter((client) => client.status === 'active' || client.id === selected)

  return (
    <Select
      aria-label="Client"
      className="h-7 text-xs"
      value={selected ?? ALL}
      onChange={(event) =>
        dispatch(clientSelected(event.target.value === ALL ? null : event.target.value))
      }
    >
      <option value={ALL}>All clients</option>
      {clients.map((client) => (
        <option key={client.id} value={client.id}>
          {client.name}
        </option>
      ))}
    </Select>
  )
}
